import useRouter from 'hooks/useRouter';
import MaintainerTicketDetailView from '../../components/MaintainerTicketDetailView';
import UIHelper from 'general/helpers/UIHelper';

MaintainerTicketDetailScreen.propTypes = {};

function MaintainerTicketDetailScreen(props) {
    // MARK: ---- PROPERTIES ----

    const router = useRouter();
    const ticketId = router.query?.ticketId;
    const { isMine } = props;

    return (
        <div>
            <div>
                {UIHelper.buildBreadcrumb([
                    {
                        title: 'Danh sách công việc',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết công việc' },
                ])}
            </div>
            <div className="my-4">
                <MaintainerTicketDetailView ticketId={ticketId} isMine={isMine} />
            </div>
        </div>
    );
}

export default MaintainerTicketDetailScreen;
